let _initProto, _initClass, _init_value, _init_extra_value, _init_min, _init_extra_min, _init_max, _init_extra_max, _init_disabled, _init_extra_disabled, _init_locale, _init_extra_locale, _init_selectionMode, _init_extra_selectionMode, _init_visibleMonths, _init_extra_visibleMonths, _init_pageBehavior, _init_extra_pageBehavior, _init_changeEvent, _init_extra_changeEvent, _init_viewYear, _init_extra_viewYear, _init_viewMonth, _init_extra_viewMonth, _init_focusedIso, _init_extra_focusedIso, _init_weekdayLabels, _init_extra_weekdayLabels, _init_monthPanels, _init_extra_monthPanels, _init_todayLabel, _init_extra_todayLabel, _init_rangeAnchor, _init_extra_rangeAnchor, _init_rangeHover, _init_extra_rangeHover;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { RadiantElement, customElement, event, onEvent, onUpdated, prop, state } from "@ecopages/radiant";
import { resolveLocale } from "@/lib/intl/locale";
import { addMonths, advanceRangeSelection, buildCalendarMonth, dateToIso, formatMonthYear, formatTodayLabel, getVisibleMonthViews, getWeekStartsOn, getWeekdayLabels, isoToDate, parseIsoRange, parseMultipleIsos, serializeIsoRange, serializeMultipleIsos, toggleMultipleIso } from "@/lib/intl-date";
let _RuiCalendar;
class RuiCalendar extends RadiantElement {
  static {
    ({
      e: [_init_value, _init_extra_value, _init_min, _init_extra_min, _init_max, _init_extra_max, _init_disabled, _init_extra_disabled, _init_locale, _init_extra_locale, _init_selectionMode, _init_extra_selectionMode, _init_visibleMonths, _init_extra_visibleMonths, _init_pageBehavior, _init_extra_pageBehavior, _init_changeEvent, _init_extra_changeEvent, _init_viewYear, _init_extra_viewYear, _init_viewMonth, _init_extra_viewMonth, _init_focusedIso, _init_extra_focusedIso, _init_weekdayLabels, _init_extra_weekdayLabels, _init_monthPanels, _init_extra_monthPanels, _init_todayLabel, _init_extra_todayLabel, _init_rangeAnchor, _init_extra_rangeAnchor, _init_rangeHover, _init_extra_rangeHover, _initProto],
      c: [_RuiCalendar, _initClass]
    } = _applyDecs(this, [customElement("rui-calendar")], [[prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "value"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "min"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "max"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "locale"], [prop({
      type: String,
      attribute: "selection-mode",
      defaultValue: "single"
    }), 0, "selectionMode"], [prop({
      type: Number,
      attribute: "visible-months",
      defaultValue: 1
    }), 0, "visibleMonths"], [prop({
      type: String,
      attribute: "page-behavior",
      defaultValue: "visible"
    }), 0, "pageBehavior"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [state, 0, "viewYear"], [state, 0, "viewMonth"], [state, 0, "focusedIso"], [state, 0, "weekdayLabels"], [state, 0, "monthPanels"], [state, 0, "todayLabel"], [state, 0, "rangeAnchor"], [state, 0, "rangeHover"], [onUpdated(["value", "min", "max", "disabled", "locale", "selectionMode", "visibleMonths", "pageBehavior"]), 2, "onPropsUpdated"], [onEvent({
      selector: "[data-calendar-prev-month]",
      type: "click"
    }), 2, "onPrevMonth"], [onEvent({
      selector: "[data-calendar-next-month]",
      type: "click"
    }), 2, "onNextMonth"], [onEvent({
      selector: "[data-calendar-today]",
      type: "click"
    }), 2, "onTodayClick"], [onEvent({
      selector: "[data-calendar-day]",
      type: "click"
    }), 2, "onDayClick"], [onEvent({
      selector: "[data-calendar-day]",
      type: "pointerenter"
    }), 2, "onDayPointerEnter"], [onEvent({
      selector: "[data-calendar-grid]",
      type: "pointerleave"
    }), 2, "onGridPointerLeave"], [onEvent({
      selector: "[data-calendar-day]",
      type: "keydown"
    }), 2, "onDayKeydown"]], 0, void 0, RadiantElement));
  }
  constructor(...args) {
    super(...args);
    _init_extra_rangeHover(this);
  }
  value = (_initProto(this), _init_value(this));
  min = (_init_extra_value(this), _init_min(this));
  max = (_init_extra_min(this), _init_max(this));
  disabled = (_init_extra_max(this), _init_disabled(this));
  locale = (_init_extra_disabled(this), _init_locale(this));
  selectionMode = (_init_extra_locale(this), _init_selectionMode(this));
  visibleMonths = (_init_extra_selectionMode(this), _init_visibleMonths(this));
  pageBehavior = (_init_extra_visibleMonths(this), _init_pageBehavior(this));
  changeEvent = (_init_extra_pageBehavior(this), _init_changeEvent(this));
  viewYear = (_init_extra_changeEvent(this), _init_viewYear(this, (/* @__PURE__ */new Date()).getFullYear()));
  viewMonth = (_init_extra_viewYear(this), _init_viewMonth(this, (/* @__PURE__ */new Date()).getMonth()));
  focusedIso = (_init_extra_viewMonth(this), _init_focusedIso(this, ""));
  weekdayLabels = (_init_extra_focusedIso(this), _init_weekdayLabels(this, []));
  monthPanels = (_init_extra_weekdayLabels(this), _init_monthPanels(this, []));
  todayLabel = (_init_extra_monthPanels(this), _init_todayLabel(this, ""));
  rangeAnchor = (_init_extra_todayLabel(this), _init_rangeAnchor(this, null));
  rangeHover = (_init_extra_rangeAnchor(this), _init_rangeHover(this, null));
  get resolvedLocale() {
    return resolveLocale(this.locale);
  }
  get pageDelta() {
    if (this.pageBehavior === "single") {
      return 1;
    }
    return Math.max(1, Math.min(this.visibleMonths, 12));
  }
  get monthOptions() {
    return {
      locale: this.resolvedLocale,
      selectionMode: this.selectionMode,
      value: this.value ?? "",
      rangeDraft: {
        anchor: this.rangeAnchor,
        hover: this.rangeHover
      },
      min: this.min || void 0,
      max: this.max || void 0
    };
  }
  syncViewFromValue() {
    const iso = this.selectionMode === "range" ? parseIsoRange(this.value)?.start ?? "" : this.selectionMode === "multiple" ? parseMultipleIsos(this.value)[0] ?? "" : this.value;
    const date = isoToDate(iso);
    if (date) {
      this.viewYear = date.getFullYear();
      this.viewMonth = date.getMonth();
      this.focusedIso = iso;
      return;
    }
    const today = /* @__PURE__ */new Date();
    this.viewYear = today.getFullYear();
    this.viewMonth = today.getMonth();
    this.focusedIso = dateToIso(today);
  }
  refreshGrid() {
    this.weekdayLabels = getWeekdayLabels(this.resolvedLocale, getWeekStartsOn(this.resolvedLocale));
    this.monthPanels = getVisibleMonthViews(this.viewYear, this.viewMonth, this.visibleMonths).map(view => {
      const viewDate = new Date(view.year, view.month, 1);
      return {
        year: view.year,
        month: view.month,
        label: formatMonthYear(viewDate, this.resolvedLocale),
        weeks: buildCalendarMonth(view.year, view.month, this.monthOptions)
      };
    });
    this.todayLabel = formatTodayLabel(this.resolvedLocale);
  }
  moveMonth(delta) {
    const next = addMonths(this.viewYear, this.viewMonth, delta);
    this.viewYear = next.year;
    this.viewMonth = next.month;
    this.refreshGrid();
  }
  getFlatDays() {
    return this.monthPanels.flatMap(panel => panel.weeks.flat());
  }
  moveFocusedDay(delta) {
    const cells = this.getFlatDays().filter(cell => !cell.isDisabled);
    if (!cells.length) {
      return;
    }
    const currentIndex = cells.findIndex(cell => cell.iso === this.focusedIso);
    const nextIndex = currentIndex < 0 ? Math.max(0, cells.findIndex(cell => cell.inMonth)) : (currentIndex + delta + cells.length) % cells.length;
    const next = cells[nextIndex];
    if (!next) {
      return;
    }
    if (!this.isMonthVisible(next.date)) {
      this.viewYear = next.date.getFullYear();
      this.viewMonth = next.date.getMonth();
      this.focusedIso = next.iso;
      this.refreshGrid();
      this.focusFocusedDay();
      return;
    }
    this.focusedIso = next.iso;
    this.focusDayInCurrentGrid(next.iso);
  }
  isMonthVisible(date) {
    const visibleStart = this.viewYear * 12 + this.viewMonth;
    const visibleEnd = visibleStart + this.visibleMonths - 1;
    const target = date.getFullYear() * 12 + date.getMonth();
    return target >= visibleStart && target <= visibleEnd;
  }
  /** Moves roving focus without rebuilding a grid that already contains the target day. */
  focusDayInCurrentGrid(iso) {
    const current = this.querySelector('[data-calendar-day][tabindex="0"]');
    const candidates = Array.from(this.querySelectorAll(`[data-calendar-day][data-iso="${iso}"]:not(:disabled)`));
    const next = candidates.find(day => !day.hasAttribute("data-outside")) ?? candidates[0];
    if (!next) {
      return;
    }
    if (current && current !== next) {
      current.tabIndex = -1;
    }
    next.tabIndex = 0;
    next.focus();
  }
  /** Restores DOM focus after rebuilding the grid around a newly visible day. */
  focusFocusedDay() {
    requestAnimationFrame(() => {
      this.focusDayInCurrentGrid(this.focusedIso);
    });
  }
  moveFocusedMonth(delta) {
    const current = isoToDate(this.focusedIso) ?? new Date(this.viewYear, this.viewMonth, 1);
    const target = new Date(current.getFullYear(), current.getMonth() + delta, 1);
    const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
    const next = new Date(target.getFullYear(), target.getMonth(), Math.min(current.getDate(), lastDay));
    this.viewYear = next.getFullYear();
    this.viewMonth = next.getMonth();
    this.focusedIso = dateToIso(next);
    this.refreshGrid();
    this.focusFocusedDay();
  }
  isIsoAllowed(iso) {
    if (this.min && iso < this.min) {
      return false;
    }
    if (this.max && iso > this.max) {
      return false;
    }
    return true;
  }
  emitChange(value, extra = {}) {
    this.changeEvent.emit({
      value,
      ...extra
    });
  }
  selectSingle(iso) {
    if (!this.isIsoAllowed(iso) || iso === this.value) {
      return;
    }
    this.value = iso;
    this.emitChange(iso);
    this.refreshGrid();
  }
  selectMultiple(iso) {
    if (!this.isIsoAllowed(iso)) {
      return;
    }
    const next = serializeMultipleIsos(toggleMultipleIso(parseMultipleIsos(this.value), iso));
    if (next === this.value) {
      return;
    }
    this.value = next;
    this.emitChange(next);
    this.refreshGrid();
  }
  selectRange(iso) {
    if (!this.isIsoAllowed(iso)) {
      return;
    }
    const result = advanceRangeSelection(parseIsoRange(this.value), {
      anchor: this.rangeAnchor,
      hover: this.rangeHover
    }, iso);
    this.rangeAnchor = result.draft.anchor;
    this.rangeHover = result.draft.hover;
    if (result.committed) {
      const serialized = serializeIsoRange(result.committed);
      if (serialized !== this.value) {
        this.value = serialized;
        this.emitChange(serialized, {
          start: result.committed.start,
          end: result.committed.end
        });
      }
    }
    this.refreshGrid();
  }
  selectIso(iso) {
    if (this.selectionMode === "multiple") {
      this.selectMultiple(iso);
      return;
    }
    if (this.selectionMode === "range") {
      this.selectRange(iso);
      return;
    }
    this.selectSingle(iso);
  }
  previewRange(iso) {
    if (this.selectionMode !== "range" || !this.rangeAnchor || this.disabled) {
      return;
    }
    if (this.rangeHover === iso) {
      return;
    }
    this.rangeHover = iso;
    this.refreshGrid();
  }
  clearRangePreview() {
    if (!this.rangeHover) {
      return;
    }
    this.rangeHover = this.rangeAnchor;
    this.refreshGrid();
  }
  initialize() {
    this.syncViewFromValue();
    this.refreshGrid();
  }
  onConnected() {
    this.initialize();
  }
  onPropsUpdated() {
    if (this.selectionMode !== "range") {
      this.rangeAnchor = null;
      this.rangeHover = null;
    }
    this.syncViewFromValue();
    this.refreshGrid();
  }
  onPrevMonth(event2) {
    event2.preventDefault();
    this.moveMonth(-this.pageDelta);
  }
  onNextMonth(event2) {
    event2.preventDefault();
    this.moveMonth(this.pageDelta);
  }
  onTodayClick(event2) {
    event2.preventDefault();
    this.selectIso(dateToIso(/* @__PURE__ */new Date()));
  }
  onDayClick(event2) {
    const button = event2.target.closest("[data-calendar-day]");
    const iso = button?.getAttribute("data-iso");
    if (!iso || button?.disabled || this.disabled) {
      return;
    }
    this.selectIso(iso);
  }
  onDayPointerEnter(event2) {
    const button = event2.target.closest("[data-calendar-day]");
    const iso = button?.getAttribute("data-iso");
    if (!iso || button?.disabled) {
      return;
    }
    this.previewRange(iso);
  }
  onGridPointerLeave() {
    this.clearRangePreview();
  }
  onDayKeydown(event2) {
    if (this.disabled) {
      return;
    }
    const currentIso = event2.target.getAttribute("data-iso");
    if (currentIso) {
      this.focusedIso = currentIso;
    }
    if (event2.key === "ArrowLeft") {
      event2.preventDefault();
      this.moveFocusedDay(-1);
      return;
    }
    if (event2.key === "ArrowRight") {
      event2.preventDefault();
      this.moveFocusedDay(1);
      return;
    }
    if (event2.key === "ArrowUp") {
      event2.preventDefault();
      this.moveFocusedDay(-7);
      return;
    }
    if (event2.key === "ArrowDown") {
      event2.preventDefault();
      this.moveFocusedDay(7);
      return;
    }
    if (event2.key === "PageUp") {
      event2.preventDefault();
      this.moveFocusedMonth(event2.shiftKey ? -12 : -this.pageDelta);
      return;
    }
    if (event2.key === "PageDown") {
      event2.preventDefault();
      this.moveFocusedMonth(event2.shiftKey ? 12 : this.pageDelta);
      return;
    }
    if (event2.key === "Enter" || event2.key === " ") {
      event2.preventDefault();
      const button = event2.target;
      const iso = button.getAttribute("data-iso");
      if (iso && !button.disabled) {
        this.selectIso(iso);
      }
    }
  }
  dayDataAttributes(dayCell) {
    return {
      "data-range-start": dayCell.isRangeStart ? "true" : void 0,
      "data-range-end": dayCell.isRangeEnd ? "true" : void 0,
      "data-range-middle": dayCell.isRangeMiddle ? "true" : void 0
    };
  }
  render() {
    const panelCount = this.monthPanels.length;
    const multiMonth = panelCount > 1;
    return /* @__PURE__ */jsxs("div", {
      class: `rui-calendar${multiMonth ? " rui-calendar--multi" : ""}`,
      "data-ref": "root",
      role: "application",
      "aria-label": "Calendar",
      "aria-multiselectable": this.selectionMode === "multiple" ? "true" : void 0,
      children: [/* @__PURE__ */jsx("div", {
        class: "rui-calendar__months",
        children: this.monthPanels.map((panel, index) => /* @__PURE__ */jsxs("div", {
          class: "rui-calendar__month-panel",
          "data-calendar-month-panel": true,
          children: [/* @__PURE__ */jsxs("div", {
            class: "rui-calendar__header",
            children: [index === 0 ? /* @__PURE__ */jsx("button", {
              type: "button",
              class: "rui-calendar__nav",
              "data-calendar-prev-month": true,
              "aria-label": "Previous month",
              disabled: this.disabled,
              children: "\u2039"
            }) : /* @__PURE__ */jsx("span", {
              class: "rui-calendar__nav-spacer",
              "aria-hidden": "true"
            }), /* @__PURE__ */jsx("div", {
              class: "rui-calendar__month",
              "aria-live": "polite",
              children: panel.label
            }), index === panelCount - 1 ? /* @__PURE__ */jsx("button", {
              type: "button",
              class: "rui-calendar__nav",
              "data-calendar-next-month": true,
              "aria-label": "Next month",
              disabled: this.disabled,
              children: "\u203A"
            }) : /* @__PURE__ */jsx("span", {
              class: "rui-calendar__nav-spacer",
              "aria-hidden": "true"
            })]
          }), index === 0 ? /* @__PURE__ */jsx("div", {
            class: "rui-calendar__weekdays",
            role: "row",
            children: this.weekdayLabels.map(label => /* @__PURE__ */jsx("div", {
              class: "rui-calendar__weekday",
              role: "columnheader",
              "aria-hidden": "true",
              children: label
            }))
          }) : null, /* @__PURE__ */jsx("div", {
            class: "rui-calendar__grid",
            role: "grid",
            "data-calendar-grid": true,
            children: panel.weeks.map(weekRow => /* @__PURE__ */jsx("div", {
              class: "rui-calendar__week",
              role: "row",
              children: weekRow.map(dayCell => /* @__PURE__ */jsx("button", {
                type: "button",
                class: "rui-calendar__day",
                "data-calendar-day": true,
                "data-iso": dayCell.iso,
                role: "gridcell",
                disabled: this.disabled || dayCell.isDisabled,
                tabIndex: dayCell.iso === this.focusedIso ? 0 : -1,
                "aria-selected": dayCell.isSelected ? "true" : "false",
                "aria-current": dayCell.isToday ? "date" : void 0,
                "data-outside": dayCell.inMonth ? void 0 : "true",
                ...this.dayDataAttributes(dayCell),
                children: dayCell.date.getDate()
              }))
            }))
          })]
        }))
      }), /* @__PURE__ */jsx("div", {
        class: "rui-calendar__footer",
        children: /* @__PURE__ */jsx("button", {
          type: "button",
          class: "rui-calendar__today",
          "data-calendar-today": true,
          disabled: this.disabled,
          children: this.todayLabel
        })
      })]
    });
  }
  static {
    _initClass();
  }
}
export { _RuiCalendar as RuiCalendar };